import { createContext } from 'react';

/**
 *
 * @type {React.Context<>}
 */
const zoneContext = createContext({
  getElementPosition: () => void 0,
  registerElement: () => () => void 0,
  zone_id: undefined,
});

export default zoneContext;
